import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { arrayToUrlQueryString } from "src/utils/api/query_param_helpers"

export const queryInvoices = ({
  marinaSlug,
  reservationId,
  page,
  pageSize = 25,
}) => {
  return queryApi(
    `/reservations/${reservationId}/invoices?marina_slug=${marinaSlug}&non_zero_amount_or_canceled_with_reversal=true&page=${page}&page_size=${pageSize}`
  )
}

export const queryInvoiceTxns = ({
  invoiceId,
  marinaSlug,
  page,
  pageSize = 25,
}) => {
  return queryApi(
    `/invoices/${invoiceId}/invoice_txns?marina_slug=${marinaSlug}&page=${page}&page_size=${pageSize}`
  )
}

export const queryRefundablePaymentMethods = ({
  reservationId,
  marinaSlug,
  isSettling = false,
}) => {
  return queryApi(
    `/reservations/${reservationId}/refundable_payment_methods?marina_slug=${marinaSlug}&is_settling=${isSettling}`
  )
}

export const querySaleRefundablePaymentMethods = ({ saleId, marinaSlug }) => {
  return queryApi(
    `/sales/${saleId}/refundable_payment_methods?marina_slug=${marinaSlug}`
  )
}

export const updateInvoice = ({ invoiceId, marinaSlug, data }) => {
  return mutateApi({
    url: `/invoices/${invoiceId}?marina_slug=${marinaSlug}`,
    method: "PATCH",
    data,
  })
}

export const createInvoiceTxn = ({ invoiceId, marinaSlug, data }) => {
  return mutateApi({
    url: `/invoices/${invoiceId}/txns?marina_slug=${marinaSlug}`,
    method: "POST",
    data,
  })
}

export const getConvenienceFeeCopy = ({ invoiceId, marinaSlug }) => {
  return queryApi(
    `/invoices/${invoiceId}/convenience_fee_copy?marina_slug=${marinaSlug}`
  )
}

export const mergeInvoices = ({
  sourceInvoiceId,
  destinationInvoiceId,
  marinaSlug,
}) => {
  return mutateApi({
    url: `/invoices/${sourceInvoiceId}/merge?marina_slug=${marinaSlug}`,
    method: "POST",
    data: {
      destination_invoice_id: destinationInvoiceId,
    },
  })
}

export const queryContactInvoices = ({
  contactId,
  marinaSlug,
  dueDateLteq,
  dueDateGteq,
  statuses,
  sortBy,
  sortDirection,
}) => {
  const params = new URLSearchParams({
    marina_slug: marinaSlug,
  })

  if (dueDateLteq) params.append("due_date_lteq", dueDateLteq)
  if (dueDateGteq) params.append("due_date_gteq", dueDateGteq)
  if (sortBy) params.append("sort_by", sortBy)
  if (sortDirection) params.append("sort_direction", sortDirection)

  const statusQueryString = arrayToUrlQueryString({
    queryParam: "statuses",
    values: statuses,
  })
  const baseUrl = `/contact/${contactId}/invoices`
  const queryParams = `${params.toString()}${statusQueryString}`

  return queryApi(`${baseUrl}?${queryParams}`)
}
